export enum USER_APPROVAL_STATUS {
  PENDING = 0,
  APPROVED = 1,
  DISAPPROVED = 2
};
